import MainLayout from "../../common/components/MainLayout"
import BuscadorInfracciones from "../components/BuscarInfracciones"


export default () => {
    
    return (
    <MainLayout maxContentWidth={90}>
        <BuscadorInfracciones/>
        {/* <TablaInfracciones tableData={resultados}></TablaInfracciones> */}
    </MainLayout>)
}